import { Injectable } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { GpsLocationService } from 'shared';

@Injectable({ providedIn: 'root' })
export class GpsService {
  constructor(private gpsLocationService: GpsLocationService) {
  }

  async requestUseGpsPermission() {
    console.log('📍 Запит дозволу на використання геолокації');
    const perm = await Geolocation.requestPermissions({ permissions: ['coarseLocation', 'location'] });
    if (perm.location !== 'granted') {
      console.warn('❌ Користувач не дозволив геолокацію');
      return;
    }

    const coords = await Geolocation.getCurrentPosition();
    // this.gpsLocationService.updateLocation(coords.coords).subscribe();
  }

  async getCurrentPosition() {
    try {
      const position = await Geolocation.getCurrentPosition();
      // this.gpsLocationService.updateLocation(position.coords).subscribe();
      return position.coords;
    } catch (error) {
      console.error('❌ Помилка отримання геолокації:', error);
      throw error;
    }
  }
}
